// front-end call api

import { api } from "@/services.js";

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///  ACCESS COMPANY  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////
export function selectUserAccessCompanyId(companyId, enterprises, user) {
  var userAccess = {};
  let session = "access" + companyId;

  if (!enterprises) return;
  //
  if (sessionStorage.getItem(session)) return;
  //
  let profile = "";
  for (let i = 0; i < enterprises.length; ++i) {
    if (companyId == enterprises[i].companyId) {
      profile = enterprises[i].profile;
      break;
    }
  }
  // // console.log("profile = " + JSON.stringify(profile));

  //
  api
    .get(`/userAccess/select/?userId=${user.userId}&companyId=${Number(companyId)}&profile=${profile}&entity=${user.entity}&groupId=${user.groupId}`)
    .then(response => {
      userAccess = response.data;
      // // console.log("userAccess" + JSON.stringify(userAccess));
      sessionStorage.setItem(session, JSON.stringify(userAccess));
    })
    .catch(err => {
      console.info("Api error => selectUserAccessCompanyId - " + companyId + " " + err);
    })
    .finally(() => {});
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///  SETTING  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////
export function selectSettingPage(pageId) {
  return api
    .get(`/setting/page/?pageId=${pageId}`)
    .then(response => {
      sessionStorage.setItem(pageId + "Setting", JSON.stringify(response.data));
      // // console.log("Setting = " + JSON.stringify(response.data));
    })
    .catch(err => {
      console.info("Api error => selectSettingPage-" + pageId + " " + err);
    });
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///  PREFER  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////
export function selectPreferPage(groupUser, pageId) {
  // // console.log("Prefer pageId = " + pageId);
  if (pageId == "cashflow" || pageId == "cashflowSelect") return;
  if (pageId == "conciliation" || pageId == "conciliationSelect") return;
  if (pageId == "cnab" || pageId == "cnabSelect") return;
  if (pageId == "cnabreturn" || pageId == "cnabreturnSelect") return;
  if (pageId == "managenfe") return;

  //
  return api
    .get(`/prefer/?pageId=${pageId}`)
    .then(response => {
      localStorage.setItem(groupUser + pageId + "Prefer", JSON.stringify(response.data));
      // used later to compare if the prefer has changed
      localStorage.setItem(groupUser + pageId + "PreferPrevious", JSON.stringify(response.data));
      // // console.log("Prefer = " + JSON.stringify(response.data));
    })
    .catch(err => {
      console.info("Api error => selectPrefer-" + pageId + " " + err);
    });
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///  LAYOUT MODEL  //////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////
export function selectLayoutModel(groupUser, layoutId, layoutModelId, modelId, viewProductSupplier, t) {
  let layout = {
    autoTableSrc: false
  };
  let selectedHeaders = []; // Header PurchaseGrid.vue
  let imprintPage = []; // PDF
  let headerAutoTable = []; // PDF Header Grid
  //
  api
    .get(
      `/layout/model/?layoutId=${layoutId}&layoutModelId=${layoutModelId}&purpose=2&modelId=${modelId}&viewProductSupplier=${viewProductSupplier}` // 1=maintenance 2=display
    )
    .then(response => {
      let headers = response.data.layoutModel;
      //
      let order = 0;
      let gridAlreadyMarked = false;
      // selectedHeaders ///////////////////////////////////
      for (let i = 0; i < headers.length; ++i) {
        let item = {};

        if (headers[i].visible || headers[i].imprint) {
          item.value = headers[i].value;
          // Title
          if (headers[i].title) {
            item.text = headers[i].title;
          } else {
            item.text = t(headers[i].label + "." + headers[i].text); // vue3 -->  i18n --> t
            // item.text = headers[i].text;
          }
          item.title = item.text; // vuetify v3 --> title v-data-table
          item.align = headers[i].align;
          item.sortable = headers[i].sortable;
          item.imprint = headers[i].imprint;
          item.grid = headers[i].grid;
          //
          if (headers[i].grid && (headers[i].visible || headers[i].imprint) && item.value != "descriptionComplementary") {
            ///////////////////////////////////////////////////////
            // header v-data-table
            if (headers[i].visible) {
              selectedHeaders.push(item);
            }
            ///////////////////////////////////////////////////////
            // header jsPDF autotable
            if (headers[i].imprint) {
              let dataKey = item.value;
              dataKey = dataKey.replace("dateDelivery", "dateDeliveryLocale");
              dataKey = dataKey.replace("dateNeed", "dateNeedLocale");
              dataKey = dataKey.replace("dateDeadline", "dateDeadlineLocale");

              if (dataKey === "src") {
                dataKey = "srcX";
                layout.autoTableSrc = true;
              }
              const column = {
                title: item.text,
                dataKey: dataKey
              };
              headerAutoTable.push(column);
            }
          }
          if (headers[i].imprint) {
            ///////////////////////////////////////////////////////
            // jsPDF
            if (!headers[i].grid || (headers[i].grid && !gridAlreadyMarked)) {
              order = order + 1;
              item.order = order;
              imprintPage.push(item);
              if (headers[i].grid) gridAlreadyMarked = true;
            }
          }
        }
      }
      //////////////////////////////////////////////////////
      // props /////////////////////////////////////////////
      // Layout Page
      layout.selectedHeaders = selectedHeaders;
      layout.displayGrid = response.data.displayGrid;
      layout.displayPage = response.data.displayPage;
      // Layout PDF
      layout.layout = response.data.layout;
      layout.imprintPage = imprintPage;
      layout.headerAutoTable = headerAutoTable;
      //  localStorage
      localStorage.setItem(groupUser + layoutId + "Layout", JSON.stringify(layout));
      //
    })
    .catch(err => {
      console.info("Api error => selectLayoutModel-" + layoutId + " " + err);
    });
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///  ENTERPRISE  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////
export function consultEnterprise(pageId, companyId) {
  return api
    .get(`/enterprise/?companyId=${companyId}`)
    .then(response => {
      // // console.log("0 enterprise=" + JSON.stringify(response.data));
      sessionStorage.setItem(
        // user in pdf header
        "enterprise",
        JSON.stringify(response.data)
      );
    })
    .catch(err => {
      console.info("Api error => consultEnterprise-" + pageId + " " + err);
    });
}
